import React from "react";
import { useNavigate } from "react-router-dom";
import config from "../../../config";
import "./ExploreYourself.css";
import { useState } from "react";

const ExploreYourself = () => {
  const navigate = useNavigate();
  const [seeAll, setSeeAll] = useState(false);

  const questions = seeAll
    ? config.PREMADE_AI_QUESTIONS
    : Object.fromEntries(
        Object.entries(config.PREMADE_AI_QUESTIONS).slice(0, 6),
      );

  return (
    <div className="explore-yourself-container">
      <div className="fw-700 fs-20 fc-black mb-20">Explore yourself</div>
      {Object.entries(questions).map(([key, value]) => (
        <div
          key={key}
          className="explore-yourself-option fw-700 fvc"
          onClick={() => navigate(`/chat-ai?qid=${key}`)}
          style={{ cursor: "pointer" }}
        >
          <div className="fs-16 fc-black">{value}</div>
          <div className="explore-yourself-btn-explore btn-denary fs-1334">
            Explore
          </div>
        </div>
      ))}
      <button
        className="btn-primary mt-20 explore-yourself-btn-see-all"
        onClick={() => {
          setSeeAll(!seeAll);
        }}
      >
        See {seeAll ? "less" : "all"} recommendations
      </button>
    </div>
  );
};

export default ExploreYourself;
